module.exports = __webpack_public_path__ + "static/media/Botany.22877bb9.svg";